import { Empty, List, Space, Tag, Tooltip, Typography } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { queryKeys } from '@/shared/api/queryKeys'
import { fetchAuthLog } from '@/features/session/sessionApi'
import { relativeFromNow } from '@/features/session/relativeTime'
import { formatDateTime, utcTooltip } from '@/shared/lib/format'
import { EMPTY_TABLE_STATE } from '@/shared/ui/table/tableState'

/** Bosh sahifada nechta urinish ko'rsatiladi. To'lig'i — `/sessions?tab=auth`. */
const RECENT_LIMIT = 5

/**
 * Bosh sahifadagi "oxirgi kirish urinishlari" — `radpostauth` ning so'nggi
 * yozuvlari.
 *
 * NEGA BOSH SAHIFADA: eski MVP panelida bu bor edi va egasi uni aynan shu
 * yerda so'radi. Sababi amaliy — "internet ishlamayapti" degan qo'ng'iroqda
 * birinchi savol "urinish umuman bo'ldimi va nima javob qaytdi" bo'ladi.
 * Faol sessiyalar jadvali bu savolga javob BERMAYDI: u faqat ULANA
 * OLGANLARNI ko'rsatadi, muammo esa aynan ulanolmaganlarda.
 *
 * ⚠️ PAROL YO'Q. `radpostauth.pass` da abonent kiritgan parol turadi va u
 * javobga umuman chiqarilmaydi (CLAUDE.md §7) — bu yerda "ko'rsatmaslik"
 * emas, "umuman kelmaydi".
 */
export function RecentAuthPanel() {
  const { t } = useTranslation()

  const query = useQuery({
    queryKey: queryKeys.sessions.recentAuth,
    queryFn: ({ signal }) =>
      fetchAuthLog({ ...EMPTY_TABLE_STATE, pageSize: RECENT_LIMIT }, signal),
    // Jadvalning qolgan qismi bilan bir xil davr — bosh sahifada ikki xil
    // yoshdagi ma'lumot turmasin
    refetchInterval: 15_000,
  })

  if (query.isError) {
    return (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t('authLog.loadFailed')}
      </Typography.Text>
    )
  }

  return (
    <List
      loading={query.isPending}
      dataSource={query.data ? [...query.data.items] : []}
      locale={{
        emptyText: (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('dashboard.noAuthRecords')} />
        ),
      }}
      renderItem={(attempt) => (
        <List.Item key={attempt.id}>
          <Space direction="vertical" size={0} style={{ width: '100%' }}>
            <Space align="center" size={8} wrap>
              <Tooltip title={attempt.reply ?? ''}>
                <Tag color={attempt.accepted ? 'green' : 'red'} style={{ marginInlineEnd: 0 }}>
                  {attempt.accepted ? t('authReply.accept') : t('authReply.reject')}
                </Tag>
              </Tooltip>
              <Link to={`/subscribers?q=${encodeURIComponent(attempt.username)}`}>
                <Typography.Text strong>{attempt.username}</Typography.Text>
              </Link>
            </Space>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {/* Nisbiy vaqt — javobning o'zi; aniq vaqt tooltip'da */}
              <Tooltip title={utcTooltip(attempt.authDate)}>
                {relativeFromNow(attempt.authDate, t)}
              </Tooltip>
              {attempt.callingStationId ? ` · ${attempt.callingStationId}` : ''}
              {attempt.calledStationId ? ` · ${attempt.calledStationId}` : ''}
            </Typography.Text>
            <Typography.Text type="secondary" style={{ fontSize: 11 }}>
              {formatDateTime(attempt.authDate)}
            </Typography.Text>
          </Space>
        </List.Item>
      )}
    />
  )
}
